// Problem section configuration
// Defines fields, validation, and metadata for the problem definition step
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for problem section
export const problemSectionSchema = z.object({
  specificProblem: z.string().min(1, 'Este campo es requerido'),
  whoSuffers: z.string().min(1, 'Este campo es requerido'),
  whyImportantNow: z.string().min(1, 'Este campo es requerido'),
});

export type ProblemSectionData = z.infer<typeof problemSectionSchema>;

// Section config
export const problemSection: SectionConfig = {
  id: 'problem',
  titleKey: 'Resolución de problema',
  descriptionKey: 'Describe el problema que resuelve tu startup',
  validationSchema: problemSectionSchema,
  fields: [
    {
      name: 'specificProblem',
      type: 'textarea',
      label: '¿Qué problema específico resuelve tu StartUp?',
      placeholder: 'Describe el problema principal...',
      required: true,
    },
    {
      name: 'whoSuffers',
      type: 'textarea',
      label: '¿Quién sufre este problema?',
      placeholder: 'Describe quién experimenta este problema...',
      required: true,
    },
    {
      name: 'whyImportantNow',
      type: 'textarea',
      label: '¿Por qué este problema es importante hoy?',
      placeholder: 'Explica la urgencia o relevancia actual...',
      required: true,
    },
  ],
};
